import Vue from 'vue';
import App from './App.vue';
import mixin from './mixin.js';

Vue.prototype.$initialData = window.initialData;

new Vue({
	el: '#app',
	mixins: [mixin],
	components: {
		'hp-app': App
	}
});
